const debug = self.debug('fetch');
const success = self.debug('fetch:success');
const failure = self.debug('fetch:failure');

function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    success(response.url);
    return response;
  }

  failure(response.url);

  const error = new Error(response.statusText);
  error.response = response;
  error.code = response.status;
  throw error;
}

function request(url, options) {
  debug(url);
  return fetch(url, options)
    .then(checkStatus)
    .then((response) => response.json()) // parse JSON
}

export default request;